export default __webpack_public_path__ + "static/card-5-1dd169ddc33986826882c7e283c4aee0.png";